module.exports = __webpack_public_path__ + "img/09ccige.c142a93e.png";